import { Component, OnInit, ViewChild, OnDestroy, Inject, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
// import { ApplicationInfoService } from 'app/core/service/application-info.service';
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { PatientService } from '../../../service/patient.service';
import { common } from 'src/app/config/enum';
import { LoaderService } from 'src/app/modules/shared/services/loader.service';
import { DialogService } from 'src/app/core/dialog.service';
import { ToastService } from 'src/app/modules/shared/services/toaster.service';
import { ToasterComponent } from 'src/app/modules/shared/component/toaster/toaster.component';
import { ErrorToasterComponent } from 'src/app/modules/shared/component/error-toaster/error-toaster.component';
@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit, OnDestroy {
  public QRTypeForm: FormGroup;
  public isVerified = false;
  public resend = false;
  private display: string;
  private time;
  public isOtpVerified = false;
  isValidOtp = false;
  isOtpEmpty: boolean = false;
  private otp: string = '';
  public showOtpComponent = true;
  public keyTypeList: any = [{ value: "ATTENDANT", name: "Attendant" }, { value: "VISITOR", name: "Visitor" }, { value: "BOTH", name: "Both" }];
  attendantQRData = JSON.stringify(this.data.patientData);
  visitorQRData = JSON.stringify(this.data.patientData);
  imageChangedEvent: any = '';
  croppedImage: any = '';
  url: any = '';
  databaseUrl: string;
  val = null;
  @ViewChild('fileinput', { static: false }) fileInput: ElementRef;
  @ViewChild('attendedParent', { static: true }) attendedParent: ElementRef;
  @ViewChild('visitorParent', { static: true }) visitorParent: ElementRef;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: ''
  };
  selectedKey = '';
  attendantKey = '';
  visitorKey = '';
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    public toastService: ToastService,
    private patientService: PatientService,
    private loaderService: LoaderService,
    public snackBar: MatSnackBar,
    private dialogService: DialogService,
    public dialogRef: MatDialogRef<OtpComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog
  ) { }

  public ngOnInit() {
    // this.attendantQRData = `Patient ID: ${this.data.patientData.patientId}, Patient Name: ${this.data.patientData.patientName}, Doctor Name: ${this.data.patientData.doctorName}, Card Nature: ${this.data.patientData.cardNature}`
    // this.visitorQRData = `Patient ID: ${this.data.patientData.patientId}, Patient Name: ${this.data.patientData.patientName}, Doctor Name: ${this.data.patientData.doctorName}, Card Nature: ${this.data.patientData.cardNature}`
    let attendantData = {
      attendantCode: this.data.attendantCode,
      customerId: localStorage.getItem('customerId'),
      deptName: this.data.departmentName,
      admittedDoctorName: this.data.doctorName,
      mobileNo: this.data.mobileNo,
      patientId: this.data.patientId,
      patientName: this.data.patientFirstName,
      roomNo: this.data.roomNumber,
      otp: this.data.otp,
      natureOfCard: "attendant",
    }
    this.attendantQRData = JSON.stringify(attendantData);
    let visitorData = {
      customerId: localStorage.getItem('customerId'),
      visitorCode: this.data.visitorCode,
      deptName: this.data.departmentName,
      admittedDoctorName: this.data.doctorName,
      mobileNo: this.data.mobileNo,
      patientId: this.data.patientId,
      patientName: this.data.patientFirstName,
      roomNo: this.data.roomNumber,
      otp: this.data.otp,
      natureOfCard: "visitor",
    }
    this.visitorQRData = JSON.stringify(visitorData);
    this.initialiseForm();
  }

  private initialiseForm() {
    this.QRTypeForm = this.formBuilder.group({
      keyType: ['', [Validators.required]],
    });
  }

  getKey() {
    this.selectedKey = this.QRTypeForm.value.keyType;
  }

  onDismiss(): void {
    this.dialogRef.close();
  }

  public onOtpChange(otp) {
    this.otp = otp;
    this.isOtpEmpty = false;
    if (this.otp.length === 4) {
      this.isValidOtp = true;
    } else {
      this.isValidOtp = false;
    }
  }

  private startTimer(duration) {
    this.display = "02:00";
    this.resend = false;
    var timer = duration, minutes, seconds;
    this.time = setInterval(() => {
      minutes = Math.floor(timer / 60);
      seconds = timer % 60;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      this.display = minutes + ":" + seconds;
      document.getElementById("time").innerHTML = this.display;
      if (--timer < 0) {
        this.resend = true;
        window.clearInterval(this.time);
      }
    }, 1000);
  }

  public verifyOtp() {
    if (this.otp != '') {
      this.isOtpEmpty = true;

      this.patientService.verifyOTP(this.data.mobileNo, this.otp)
        .subscribe((res) => {
          if (res['data']) {
            this.openSnackBar('success', 'Mobile Number Verified');
            this.isOtpVerified = true;
          } else {
            this.openSnackBar('success', 'Invalid OTP');
          }
        }, (error) => {
          this.errorSnackBar(error);
        })
    } else if (this.otp === '') {
      this.isOtpEmpty = true;
    }
  }

  async saveAsImage(attendedParent, visitorParent?) {
    let attendantBlobData;
    let visitorBlobData;
    // fetches base 64 date from image
    if (this.selectedKey == 'ATTENDANT' || this.selectedKey == 'BOTH') {
      const attendentElement = attendedParent.qrcElement.nativeElement.querySelector("img").src;
      attendantBlobData = this.convertBase64ToBlob(attendentElement);
      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) { //IE
        (window.navigator as any).msSaveOrOpenBlob(attendantBlobData, 'Qrcode');
      } else { // chrome
        const blob = new Blob([attendantBlobData], { type: "image/png" });
        let formData: FormData = new FormData();
        formData.append('file', blob);
        this.attendantKey = await this.patientService.uploadFile(formData).toPromise();
      }
    }
    if (this.selectedKey == 'VISITOR' || this.selectedKey == 'BOTH') {
      const visitorElement = visitorParent.qrcElement.nativeElement.querySelector("img").src;
      visitorBlobData = this.convertBase64ToBlob(visitorElement);
      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) { //IE
        (window.navigator as any).msSaveOrOpenBlob(visitorBlobData, 'Qrcode');
      } else { // chrome
        const blob = new Blob([visitorBlobData], { type: "image/png" });
        let formData: FormData = new FormData();
        formData.append('file', blob);
        this.visitorKey = await this.patientService.uploadFile(formData).toPromise();
      }
    }
    this.patientService.QRCode(this.data.id, this.attendantKey, this.visitorKey, this.selectedKey)
      .subscribe(res => {
        this.dialogRef.close();
        this.openSnackBar('success', res['description']);
      }, error => {
        this.errorSnackBar(error);
      })
  }
  private convertBase64ToBlob(Base64Image: any) {
    // SPLIT INTO TWO PARTS
    const parts = Base64Image.split(';base64,');
    // HOLD THE CONTENT TYPE
    const imageType = parts[0].split(':')[1];
    // DECODE BASE64 STRING
    const decodedData = window.atob(parts[1]);
    // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
    const uInt8Array = new Uint8Array(decodedData.length);
    // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // RETURN BLOB IMAGE AFTER CONVERSION
    return new Blob([uInt8Array], { type: imageType });
  }

  public cancel() {
    this.dialogRef.close();
  }

  errorSnackBar(error) {
    this.toastService.opentoast(
      { toastName: '', data: { errorCode: error.status, error: error.error }, type: 'error' },
      ErrorToasterComponent
    );
  }

  openSnackBar(panelClass: string, message?) {
    if (panelClass === 'Imagesize-not-supported') {
      this.toastService.opentoast({
        toastName: 'Image-size-not-supported',
        data: { name: '' },
      });
    }
    else if (panelClass === 'success') {
      this.toastService.opentoast(
        { toastName: 'success', data: { name: '', message }, type: 'success' },
        ToasterComponent
      );
    }
  }
  public ngOnDestroy() {
    window.clearInterval(this.time);
  }
}
